import { httpClient } from './http-client';
import { News } from './types';
import { NewsArticle } from '@/types/news.types';

export const newsService = {
  /**
   * Get all news
   */
  async getAllNews(): Promise<NewsArticle[]> {
    const rawNews = await httpClient.get<News[]>('/api/v1/news');
    return rawNews.map(mapNewsToFrontend);
  },

  /**
   * Get a single news article by slug
   */
  async getBySlug(slug: string): Promise<NewsArticle | null> {
    const allNews = await this.getAllNews();
    return allNews.find(n => n.slug === slug) || null;
  },

  /**
   * Get latest 6 news
   */
  async getLatestNews(): Promise<NewsArticle[]> {
    const rawNews = await httpClient.get<News[]>('/api/v1/news/latest');
    return rawNews.map(mapNewsToFrontend);
  }
};

function mapNewsToFrontend(news: any): NewsArticle {
  // Check where slug is located. It is inside seo object in the model.
  const slug = news.seo?.slug || news.slug || news._id;

  return {
    id: news._id,
    slug: slug,
    title: news.title,
    excerpt: news.description,
    content: news.content,
    category: typeof news.categoryId === 'object' && news.categoryId !== null
      ? (news.categoryId as any).categoryName
      : 'Uncategorized',
    author: news.author,
    date: news.publishedDate,
    image: news.featuredImage || '/placeholder.jpg',
    readTime: 5, // Placeholder
  };
}
